import { z } from 'zod'
import {
  addressPrimitiveSchema,
  bigintTextSchema,
  txHashSchema,
} from './primitive'

export const internalTransactionSchema = z.object({
  contractAddress: addressPrimitiveSchema.optional(),
  from: addressPrimitiveSchema,
  gas: bigintTextSchema,
  isError: z.boolean(),
  to: addressPrimitiveSchema.optional(),
  txHash: txHashSchema,
  value: bigintTextSchema,
})

export type InternalTransaction = z.infer<typeof internalTransactionSchema>

export const internalTransactionWithIndexSchema =
  internalTransactionSchema.extend({
    blockNumber: z.number(),
    timestamp: z.number(),
  })

export type InternalTransactionWithIndex = z.infer<
  typeof internalTransactionWithIndexSchema
>
